module.exports = __webpack_public_path__ + "static/media/halluxguard-4.22f41389.jpg";